import { Link } from '@framework/router/Next/Link';
import Tooltip from '@creditflowresearch/uilib/Tooltip';
import type IDealCellData from '@/creditflowresearch/ui/components/deals/DealListTable/cells/types';
import UpsizedCell from '@/creditflowresearch/ui/common/components/TableCells/UpsizedCell';

import styles from '@/creditflowresearch/ui/components/deals/DealListTable/cells/DealName/dealName.module.scss';

export const DealName = ({ row: deal }: { row: IDealCellData }) => {
  const { primaryIssuer, seriesName, link, upsized, totalSize } = deal;
  return (
    <div className={ styles.dealName }>
      <Tooltip content={ `${ primaryIssuer.name } ${ seriesName } ${ totalSize }` }>
        <Link to={ link }>
          { primaryIssuer.name } { seriesName } { totalSize }
        </Link>
      </Tooltip>
      { upsized && <UpsizedCell upsized={ upsized } /> }
    </div>
  );
};
